import type { ReportDocument } from "../../services/report";
import { UNVERIFIED_MARKER } from "./ReportStatusBlock";
import { ReportSnapshotTable } from "./ReportSnapshotTable";

// Section 8 of the sheet, the references: the stored references snapshot as stored - the
// governing references with their verification status, the reference source, a controlled-data
// pin where the module has one (EOS-07c), deviations - every leaf one row. Nothing is looked
// up again: a reference the run did not store is not on the sheet.

type ReportReferencesProps = {
  document: ReportDocument;
};

export function ReportReferences({ document }: ReportReferencesProps) {
  const status = document.status.reference_verification_status;
  const empty = Object.keys(document.references_snapshot).length === 0;
  return (
    <section aria-label="References" data-report-section="references">
      <h3>References</h3>
      <p data-report-field="reference-status">
        Verification status <strong>{status}</strong>
        {status === "VERIFIED" ? "" : ` — ${UNVERIFIED_MARKER}`}
      </p>
      {empty ? (
        <p data-report-no-references="true">No references stored with this run.</p>
      ) : (
        <ReportSnapshotTable snapshot={document.references_snapshot} caption="Stored references" />
      )}
    </section>
  );
}

export default ReportReferences;
